import { render, staticRenderFns } from "./KnTaxInfo.vue?vue&type=template&id=9d9699f0"
import script from "./KnTaxInfo.js?vue&type=script&lang=js&external"
export * from "./KnTaxInfo.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports